module.exports = __webpack_public_path__ + "static/share-siteception-d39011455b6e5ede3eb6874f42024abd.jpg";